export default __webpack_public_path__ + "static/media/2225.f37186ed.png";